/* ===============================
   GLOBAL LOCKS
================================ */

window.__upsellLock = false;
window.__cartLock = false;


/* ===============================
   UPSELL RECOMMENDATIONS
================================ */

window.fetchAndDisplayRecommendations = async function () {

  if (window.__upsellLock) return;
  window.__upsellLock = true;

  const cartItem = document.querySelector('.m-cart-item.first');
  if (!cartItem) {
    window.__upsellLock = false;
    return;
  }

  const productId = cartItem.getAttribute('data-url');
  if (!productId) {
    window.__upsellLock = false;
    return;
  }

  try {

    const response = await fetch(`${productId}?view=d5-cart-upsellls`);
    const data = await response.text();
    const doc = new DOMParser().parseFromString(data, 'text/html');

    const container = document.querySelector('.related-upsells-d5');
    if (!container) return;

    const docupsells = doc.querySelector('.upsell-con-d5');
    if (!docupsells) return;

    container.innerHTML = docupsells.innerHTML;

    container.querySelectorAll('.product-card').forEach(product => {

      const variantSelect = product.querySelector('.variant-select');
      const productImage = product.querySelector('.product-image');
      const productPrice = product.querySelector('.product-price');
      const addButton = product.querySelector('.add-to-cart-btn');

      if (!addButton) return;

      if (variantSelect) {

        variantSelect.addEventListener('change', e => {

          const option = e.target.options[e.target.selectedIndex];
          if (!option) return;

          const price = option.dataset.price;
          const image = option.dataset.image;
          const available = option.dataset.available === 'true';

          if (image && productImage) productImage.src = image;
          if (price && productPrice) productPrice.textContent = price;

          addButton.dataset.variantId = option.value;
          addButton.disabled = !available;
          addButton.textContent = available ? 'ADD' : 'SOLD OUT';

        });

        variantSelect.dispatchEvent(new Event('change'));

      }

      addButton.addEventListener('click', async () => {

        const variantId = addButton.dataset.variantId;
        if (!variantId) return;

        const originalText = addButton.textContent;

        addButton.textContent = 'ADDING...';
        addButton.disabled = true;

        try {

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!res.ok) throw new Error();

          addButton.textContent = 'ADDED!';

          if (window.updateCartUI) {
            await window.updateCartUI();
          }

        } catch (err) {

          addButton.textContent = 'ERROR';

        }

        setTimeout(() => {
          addButton.textContent = originalText;
          addButton.disabled = false;
        }, 2000);

      });

    });

  } catch (err) {

    console.error(err);

  } finally {

    window.__upsellLock = false;

  }

};


/* ===============================
   CART UI REFRESH
================================ */

window.updateCartUI = async function () {

  if (window.__cartLock) return;
  window.__cartLock = true;

  try {

    const req = await fetch('/pages/faq');
    const html = await req.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const oldBody = document.querySelector('.m-cart-drawer__body');
    const newBody = doc.querySelector('.m-cart-drawer__body');

    const oldFooter = document.querySelector('.m-cart-drawer__summary');
    const newFooter = doc.querySelector('.m-cart-drawer__summary');

    const oldCount = document.querySelectorAll('a.m-cart-icon-bubble');
    const newCount = doc.querySelectorAll('a.m-cart-icon-bubble');

    if (oldBody && newBody) oldBody.innerHTML = newBody.innerHTML;
    if (oldFooter && newFooter) oldFooter.innerHTML = newFooter.innerHTML;

    oldCount.forEach((el, i) => {
      if (newCount[i]) el.innerHTML = newCount[i].innerHTML;
    });

  } catch (err) {

    console.error(err);

  } finally {

    window.__cartLock = false;
    await window.fetchAndDisplayRecommendations();

  }

};


/* ===============================
   GIFT PRODUCT HANDLER
================================ */

document.addEventListener('click', async e => {

  const el = e.target.closest('.gift-product-d5');
  if (!el) return;

  el.style.opacity = '.4';

  const variantId = el.getAttribute('variant-id');
  const lineItemId = el.getAttribute('key');

  try {

    if (el.classList.contains('active') && lineItemId) {

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [lineItemId]: 0 } })
      });

    } else if (variantId) {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

    }

    await window.updateCartUI();

  } catch (err) {

    console.error(err);

  }

});


/* ===============================
   INIT
================================ */

if (document.readyState === 'loading') {

  document.addEventListener('DOMContentLoaded', () => {

    window.fetchAndDisplayRecommendations();

    const removalGift = document.querySelector('.remove-gift-auto-d5');
    if (removalGift) {
      document.querySelector('.gift-product-d5.active')?.click();
    }

  });

} else {

  window.fetchAndDisplayRecommendations();

}


document.addEventListener('click', async e => {

  if (e.target.classList.contains('pcard-variant-d5')) {

    e.preventDefault();
    e.target.classList.add('loading');

    try {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: e.target.getAttribute('variant-id'),
          quantity: 1
        })
      });

      await window.updateCartUI();

      const cart = document.querySelector('.m-cart-drawer');
      if (cart) {
        cart.classList.add('m-cart-drawer--active');
        if (cart.classList.contains('m-cart--empty')) {
          cart.classList.remove('m-cart--empty');
        }
      }

      e.target.classList.remove('loading');

    } catch (err) {

      console.error(err);

    }

  }

  if (e.target.classList.contains('mobile-modal-opener-d5')) {

    e.preventDefault();
    e.target.closest('.m-product-card__media')
      .querySelector('.size-pcard-options-d5')
      .classList.add('active');

  }

  else if (!e.target.classList.contains('size-pcard-options-d5')) {

    document.querySelectorAll('.size-pcard-options-d5.active')
      .forEach(item => item.classList.remove('active'));

    if (e.target.classList.contains('gift-message-opener-d5')) {
      e.target.parentElement.classList.add('active');
    }

    if (
      e.target.classList.contains('gw-cancel-d5') ||
      e.target.classList.contains('gw-popup-d5')
    ) {
      document.querySelector('.gift-con-d5')?.classList.remove('active');
    }

    if (e.target.classList.contains('gw-save-d5')) {

      const textarea = document.querySelector('.gw-textarea-d5');
      document.querySelector('.gift-con-d5')?.classList.remove('active');

      if (textarea) {

        const value = textarea.value;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { "Gift Wrap": value || "" }
          })
        })
        .then(r => r.json())
        .then(() => {
          if (!value) textarea.value = '';
        });

      }

    }

  }

});
